(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7156"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7156"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2sx2w", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $1ca7d343bb71622c$export$6503ec6e8aabbaf; }, function (v) { return $1ca7d343bb71622c$export$6503ec6e8aabbaf = v; });
var $1ca7d343bb71622c$export$6503ec6e8aabbaf;
var $1ca7d343bb71622c$export$f7ad0328861e2f03;
"use strict";
var $1ca7d343bb71622c$var$mapping = new Map();
function $1ca7d343bb71622c$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$1ca7d343bb71622c$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $1ca7d343bb71622c$var$resolve(id) {
    var resolved = $1ca7d343bb71622c$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$1ca7d343bb71622c$export$6503ec6e8aabbaf = $1ca7d343bb71622c$var$register;
$1ca7d343bb71622c$export$f7ad0328861e2f03 = $1ca7d343bb71622c$var$resolve;

});

parcelRegister("4q2BN", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $337b9d218f6316d1$export$bdfd709ae4826697; }, function (v) { return $337b9d218f6316d1$export$bdfd709ae4826697 = v; });
var $337b9d218f6316d1$export$bdfd709ae4826697;
var $337b9d218f6316d1$export$c9e73fbda7da57b6;
var $337b9d218f6316d1$export$5a759dc7a1cfb72a;
"use strict";
var $337b9d218f6316d1$var$bundleURL = {};
function $337b9d218f6316d1$var$getBundleURLCached(id) {
    var value = $337b9d218f6316d1$var$bundleURL[id];
    if (!value) {
        value = $337b9d218f6316d1$var$getBundleURL();
        $337b9d218f6316d1$var$bundleURL[id] = value;
    }
    return value;
}
function $337b9d218f6316d1$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $337b9d218f6316d1$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $337b9d218f6316d1$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $337b9d218f6316d1$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$337b9d218f6316d1$export$bdfd709ae4826697 = $337b9d218f6316d1$var$getBundleURLCached;
$337b9d218f6316d1$export$c9e73fbda7da57b6 = $337b9d218f6316d1$var$getBaseURL;
$337b9d218f6316d1$export$5a759dc7a1cfb72a = $337b9d218f6316d1$var$getOrigin;

});

var $d91145f49f224417$exports = {};


(parcelRequire("2sx2w")).register((parcelRequire("4q2BN")).getBundleURL("cfe3w"), JSON.parse('["cfe3w","mnist-autoencoder.8c851206.js","2fbLc","mnist-encoder-leakyRelu.9959ebf5.json","am6mt","mnist-decoder-leakyRelu.04cbcc36.json","ccN7U","mnist-encoder-relu.9959ebf5.json","gzMdk","mnist-decoder-relu.4c7275b8.json","i34L8","mnist-encoder-sigmoid.9959ebf5.json","5E3ll","mnist-decoder-sigmoid.4deabd85.json","asrHb","binary-classification.0b1b0f85.js"]'));


var $d2Bw1 = parcelRequire("d2Bw1");
var $d7a952a41912786b$exports = {};

$d7a952a41912786b$exports = (parcelRequire("4q2BN")).getBundleURL("cfe3w") + "mnist-encoder-leakyRelu.9959ebf5.json";


var $6a170f2dd356a2c2$exports = {};

$6a170f2dd356a2c2$exports = (parcelRequire("4q2BN")).getBundleURL("cfe3w") + "mnist-decoder-leakyRelu.04cbcc36.json";


var $74f93e38373c1601$exports = {};

$74f93e38373c1601$exports = (parcelRequire("4q2BN")).getBundleURL("cfe3w") + "mnist-encoder-relu.9959ebf5.json";


var $a2dfe73f700093fb$exports = {};

$a2dfe73f700093fb$exports = (parcelRequire("4q2BN")).getBundleURL("cfe3w") + "mnist-decoder-relu.4c7275b8.json";


var $1e17b614edb59a54$exports = {};

$1e17b614edb59a54$exports = (parcelRequire("4q2BN")).getBundleURL("cfe3w") + "mnist-encoder-sigmoid.9959ebf5.json";


var $0f42e6e4855418cb$exports = {};

$0f42e6e4855418cb$exports = (parcelRequire("4q2BN")).getBundleURL("cfe3w") + "mnist-decoder-sigmoid.4deabd85.json";


const { Autoencoder: $483181e113ef3719$var$Autoencoder, bootstrapModel: $483181e113ef3719$var$bootstrapModel } = (0, $d2Bw1.utils);
var $483181e113ef3719$export$2e2bcd8739ae039 = async (activation)=>{
    const encoderPath = activation === "leakyRelu" && (0, (/*@__PURE__*/$parcel$interopDefault($d7a952a41912786b$exports))) || activation === "relu" && (0, (/*@__PURE__*/$parcel$interopDefault($74f93e38373c1601$exports))) || (0, (/*@__PURE__*/$parcel$interopDefault($1e17b614edb59a54$exports)));
    const decoderPath = activation === "leakyRelu" && (0, (/*@__PURE__*/$parcel$interopDefault($6a170f2dd356a2c2$exports))) || activation === "relu" && (0, (/*@__PURE__*/$parcel$interopDefault($a2dfe73f700093fb$exports))) || (0, (/*@__PURE__*/$parcel$interopDefault($0f42e6e4855418cb$exports)));
    const [encoderWeights, decoderWeights] = await Promise.all([
        fetch(encoderPath).then((res)=>res.json()),
        fetch(decoderPath).then((res)=>res.json())
    ]);
    const encoder = $483181e113ef3719$var$bootstrapModel(encoderWeights, activation);
    const decoder = $483181e113ef3719$var$bootstrapModel(decoderWeights, activation);
    return new $483181e113ef3719$var$Autoencoder(encoder, decoder);
};



var $2P5ac = parcelRequire("2P5ac");
const $733af3700e74be42$var$fetchTestData = async ()=>{
    const response = await fetch(`${""}/api/mnist?end=50&type=test`);
    const json = await response.json();
    return json;
};
const $733af3700e74be42$var$drawImage = (image)=>{
    const imageCanvas = document.createElement("canvas");
    const size = 14;
    const scale = size * 8;
    imageCanvas.width = scale;
    imageCanvas.height = scale;
    const ctx = imageCanvas.getContext("2d");
    const imageData = ctx.createImageData(size, size);
    image.forEach((pixel, idx)=>{
        const value = pixel * 255;
        imageData.data[idx * 4 + 0] = value;
        imageData.data[idx * 4 + 1] = value;
        imageData.data[idx * 4 + 2] = value;
        imageData.data[idx * 4 + 3] = 255;
    });
    // Create a temporary canvas to scale the image
    const tempCanvas = document.createElement("canvas");
    tempCanvas.width = size;
    tempCanvas.height = size;
    const tempCtx = tempCanvas.getContext("2d");
    tempCtx.putImageData(imageData, 0, 0);
    // Scale up the image and draw it on the image canvas
    ctx.imageSmoothingEnabled = false;
    ctx.drawImage(tempCanvas, 0, 0, size, size, 0, 0, scale, scale);
    return imageCanvas;
};
let $733af3700e74be42$var$testData = null;
let $733af3700e74be42$var$currentIteration = null;
const $733af3700e74be42$var$getSelectedActivation = ()=>document.querySelector('input[name="activation"]:checked').value;
const $733af3700e74be42$var$iterateImages = (id)=>async (autoencoder)=>{
        if (!$733af3700e74be42$var$testData) $733af3700e74be42$var$testData = await $733af3700e74be42$var$fetchTestData();
        for (const { image: original } of $733af3700e74be42$var$testData){
            if ($733af3700e74be42$var$currentIteration !== id) break;
            const decoded = autoencoder.forward(original);
            const reconstructed = decoded.map(({ data: pixel })=>pixel > 0.5 ? 1 : 0);
            document.getElementById("original").innerHTML = "";
            document.getElementById("reconstructed").innerHTML = "";
            document.getElementById("original").appendChild($733af3700e74be42$var$drawImage(original));
            document.getElementById("reconstructed").appendChild($733af3700e74be42$var$drawImage(reconstructed));
            await new Promise((resolve)=>{
                setTimeout(resolve, 2000);
            });
        }
    };
const $733af3700e74be42$var$main = async ()=>{
    const activation = $733af3700e74be42$var$getSelectedActivation();
    const autoencoder = await (0, $483181e113ef3719$export$2e2bcd8739ae039)(activation);
    $733af3700e74be42$var$currentIteration = Math.random();
    $733af3700e74be42$var$iterateImages($733af3700e74be42$var$currentIteration)(autoencoder);
    const size = Math.min(+document.querySelector(".demo").offsetWidth, 600);
    (0, $2P5ac.default)("#architecture", size, autoencoder.toString());
};
document.querySelectorAll('input[name="activation"]').forEach((radio)=>{
    radio.addEventListener("change", ()=>{
        if ($733af3700e74be42$var$currentIteration) $733af3700e74be42$var$currentIteration = null;
        $733af3700e74be42$var$main();
    });
});
$733af3700e74be42$var$main();

})();
//# sourceMappingURL=mnist-autoencoder.8c851206.js.map
